var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-lg-8 contentCol" }, [
    _c("h1", [_vm._v("Passwort vergessen")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: { "padding-bottom": "20px", display: "none" },
        attrs: { id: "mailSendText" }
      },
      [
        _vm._v(
          "\n\t\tDu wirst eine E-Mail mit einem Link erhalten, über den du ein neues Passwort vergeben kannst.\n\t"
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { id: "theForm" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c(
          "div",
          { staticStyle: { margin: "10px 0 20px 0", "max-width": "320px" } },
          [
            _c("div", { staticStyle: { "font-weight": "700" } }, [
              _vm._v("E-Mail-Adresse")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              attrs: { type: "text", id: "email" },
              domProps: { value: _vm.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("friendly-captcha", {
              attrs: { sitekey: _vm.recaptchaSiteKey },
              on: { done: _vm.frcDone, error: _vm.frcError }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "errorBox",
                staticStyle: { display: "none" },
                attrs: { id: "errorbox" }
              },
              [_vm._v("\n\t\t\t\tPlease solve the captcha first\n\t\t\t")]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "margin-top": "20px" } }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-white teaserButton width100",
                  on: { click: _vm.requestPassword }
                },
                [_vm._v("Absenden")]
              )
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: { "padding-bottom": "20px" },
        attrs: { id: "requestPasswordText" }
      },
      [
        _vm._v("\n\t\tBitte gib deine E-Mail ein."),
        _c("br"),
        _vm._v(
          "Du wirst eine E-Mail mit einem Link erhalten, über den du ein neues Passwort vergeben kannst.\n\t"
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0747f636", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0747f636","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestPassword.vue
// module id = 475
// module chunks = 2